import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AirworthyPill: FunctionComponent<Props> = ({
    className = '',
    label,
    readiness,
    testId = TEST_ID
}) => {
    const readinessClass = styles[`readiness${readiness}`] ?? '';

    return (
        <Wrapper
            className={`${styles.airworthyPill} ${readinessClass} ${className}`}
            testId={testId}>
            <Wrapper className={styles.dot} />

            {label}
        </Wrapper>
    );
};

export default AirworthyPill;
